import React from 'react';
export function Card({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`bg-white rounded-lg border border-slate-200 shadow-sm ${className}`} data-id="element-67">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-6 pb-4 ${className}`} data-id="element-68">{children}</div>;
}
export function CardTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className="text-lg font-semibold leading-none tracking-tight text-slate-900" data-id="element-69">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-6 pt-0 ${className}`} data-id="element-70">{children}</div>;
}